import React, { Component } from "react";
import { translate } from "react-admin";
import { verifyPasswordResetToken } from "../../utils/restUtils";
import { togglePopup } from "../../reducer/flagActions";
import { connect } from "react-redux";
import ConfirmPasswordReset from "../../components/pages/ConfirmPasswordReset";

class ConfirmPasswordResetPage extends Component {
  state = {
    token: null,
    verify: false,
    showLoginLink: false,
    showError: false
  };

  componentDidMount = () => {
    let { token } = this.props.match.params;
    this.setState({ token: token, verify: true }, () => {
      verifyPasswordResetToken(token).then(
        success => this.setState({ verify: false, showLoginLink: true }),
        error => this.setState({ verify: false, showError: true })
      );
    });
  };

  goToLogin = () => {
    this.props.dispatch(togglePopup("popupLogin"));
    this.props.history.push("/competitionList");
  };

  render = () => (
    <ConfirmPasswordReset
      translate={this.props.translate}
      verify={this.state.verify}
      showLoginLink={this.state.showLoginLink}
      showError={this.state.showError}
      goToLogin={this.goToLogin}
    />
  );
}
const mapStateToProps = state => ({});
export default connect(mapStateToProps)(translate(ConfirmPasswordResetPage));
